module.exports = __webpack_public_path__ + "img/bottomImg1.7a7255da.png";